import React from 'react';
import { 
  ProductCatalog, 
  PackagedProducts,
  PackagedPueblo,
  IlustracionCF,
  IlustracionPR
} from './products/index';

const Products = () => {
  return (
    <section id="productos" className="bg-gradient-to-br from-gray-50 to-green-50">
      <IlustracionPR />
      <PackagedPueblo />
      <IlustracionCF />
      <PackagedProducts />
      <ProductCatalog />
    </section>
  );
};

export default Products;